import * as React from "react";
import { noop } from "../../utils/function";

const FormWithSubmit = ({
  children,
  className,
  onSubmit
}) => {
  return /*#__PURE__*/React.createElement("form", {
    className: className,
    onKeyPress: event => {
      if (event.key === "Enter") {
        onSubmit();
      }
    },
    onSubmit: event => {
      event.preventDefault();
      onSubmit();
    }
  }, children);
};

FormWithSubmit.defaultProps = {
  onSubmit: noop
};
export default FormWithSubmit;